const firebaseConfig = {
  apiKey: "AIzaSyCwcmJn_UKSqs7WhAMafaYk_hUdNr5Aon4",
  authDomain: "cryptotracker-ea300.firebaseapp.com",
  databaseURL: "https://cryptotracker-ea300-default-rtdb.firebaseio.com",
  projectId: "cryptotracker-ea300",
  storageBucket: "cryptotracker-ea300.appspot.com",
  messagingSenderId: "199051556571",
  appId: "1:199051556571:web:39b3fae162e4eae15a7efe",
  measurementId: "G-DQSHBMZ5NF",
};

export default firebaseConfig;
